import { get } from 'lodash';
import moment from 'moment';
import { dateFormat } from '../../config';

export const getKapitiTransactions = (state) => {
	const transactions = get(state, 'kapitiTransactions.transactions', []);
	if (!transactions.length) return [];

	return transactions.map((transaction) => {
		const date = moment(transaction.tx_posted_date).isValid()
			? moment(transaction.tx_posted_date).format(dateFormat)
			: '';

		return {
			date,
			description: transaction.memo,
			amount: `${transaction.tx_amount}  ${transaction.currency}`,
			balance: transaction.balance_amount,
		};
	});
};

export const getAppTitle = (state) => {
	const bankId = get(state, 'session.bankId', 'VM');
	return `${bankId} Web`;
};

export const getAccountId = (state) => get(state, 'kapitiTransactions.selectedAccountId', '');
